export default "__VITE_ASSET__CBl1K5Ex__"